import { createAction, ActionsUnion } from 'utils/redux'
import { RxWebSocketStatus } from 'messaging'

export enum ConnectionActionTypes {
  SET_CREDENTIALS = 'SET_CREDENTIALS',
  CLEAR_LAST_ERRORS = 'CLEAR_LAST_ERRORS',
  FORCE_DISCONNECT = 'FORCE_DISCONNECT',
  SOCKET_STATUS = 'SOCKET_STATUS',
  SIGN_OUT = 'SIGN_OUT'
}

export const ConnectionActions = {
  setCredentials: (username: string) => createAction(ConnectionActionTypes.SET_CREDENTIALS, { username }),
  clearLastErrors: () => createAction(ConnectionActionTypes.CLEAR_LAST_ERRORS),
  forceDisconnect: () => createAction(ConnectionActionTypes.FORCE_DISCONNECT),
  socketStatus: (status: RxWebSocketStatus) => createAction(ConnectionActionTypes.SOCKET_STATUS, status),
  signOut: (errorMessage: string | null = null) => createAction(ConnectionActionTypes.SIGN_OUT, errorMessage)
}

export type ConnectionActions = ActionsUnion<typeof ConnectionActions>

export type SocketStatusAction = ReturnType<typeof ConnectionActions.socketStatus>
